import { render, staticRenderFns } from "./AttackSummary.vue?vue&type=template&id=20197536"
import script from "./AttackSummary.vue?vue&type=script&lang=js"
export * from "./AttackSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports